import App from "./App.svelte";
import { hostBaseURL } from "./urls";
class TelemetryInsightsAppWebComponent extends HTMLElement {
    constructor() {
        super(...arguments);
        this.rendered = false;
    }
    static get observedAttributes() {
        return [
            "building-code",
            "theme-font",
            "theme-primary-color",
            "theme-accent-color",
            "auth-token",
        ];
    }
    renderIfInitialized() {
        if (this.authToken &&
            this.themeFont &&
            this.themePrimaryColor &&
            this.themeAccentColor &&
            this.buildingCode &&
            this.mountPoint &&
            !this.rendered) {
            this.renderApp();
        }
    }
    attributeChangedCallback(name, oldValue, newValue) {
        switch (name) {
            case "building-code":
                this.buildingCode = newValue;
                break;
            case "theme-font":
                this.themeFont = newValue;
                break;
            case "theme-primary-color":
                this.themePrimaryColor = newValue;
                break;
            case "theme-accent-color":
                this.themeAccentColor = newValue;
                break;
            case "auth-token":
                this.authToken = newValue;
                break;
            default:
                break;
        }
        this.renderIfInitialized();
    }
    connectedCallback() {
        this.mountPoint = document.createElement("div");
        const shadowRoot = this.attachShadow({ mode: "open" });
        shadowRoot.appendChild(this.mountPoint);
        const linkElement = document.createElement("link");
        linkElement.rel = "stylesheet";
        linkElement.href = `${hostBaseURL}/bundle.css`;
        shadowRoot.appendChild(linkElement);
        this.renderIfInitialized();
    }
    disconnectedCallback() {
        var _a;
        (_a = this.app) === null || _a === void 0 ? void 0 : _a.$destroy();
    }
    renderApp() {
        if (this.mountPoint) {
            this.app = new App({
                target: this.mountPoint,
                props: {
                    authToken: this.authToken,
                    themeFont: this.themeFont,
                    themePrimaryColor: this.themePrimaryColor,
                    themeAccentColor: this.themeAccentColor,
                    buildingCode: this.buildingCode,
                },
            });
            this.rendered = true;
        }
        else {
            console.error("renderApp called while mountPoint undefined");
        }
    }
}
window.customElements.define("telemetry-insights-app", TelemetryInsightsAppWebComponent);
